import { useState } from "react";
import DeleteIcon from "../../IconsCode/DeleteIcon";
import FilterOrganization from "./FilterOrganization";
import SearchUser from "./SearchUser";
import DeleteMultiUsers from "../Modal/DeleteMultiUsers";
import PlusIcon from "../../../Icons/PlusIcon";

function UserHeader({
    selectedUsers,
    users,
    setSelectedUsers,
    setOpenAddUser,
    handleSearch,
    setFilterOrg,
    openError,
    openSuccess
}) {
    const [openDeleteMulti, setOpenDeleteMulti] = useState(false);

    return (
        <>
            <div className="mb-4 flex flex-row-reverse items-center justify-between">
                {selectedUsers.length > 0 ? (
                    <div className="flex flex-row-reverse items-center">
                        <input
                            type="checkbox"
                            className="ml-2 w-4 h-4 cursor-pointer"
                            checked={selectedUsers.length === users.length}
                            onChange={(e) =>
                                setSelectedUsers(
                                    e.target.checked ? users.map((u) => u.id) : []
                                )
                            }
                        />
                        <span>انتخاب همه</span>
                        <button
                            onClick={() => setOpenDeleteMulti(true)}
                            className="flex flex-row-reverse items-center mx-8 py-2 px-8 rounded-lg bg-primary-500 text-white"
                        >
                            <DeleteIcon color="#fff" size="24" />
                            حذف
                        </button>
                    </div>
                ) : (
                    <h1 className="text-lg font-bold">لیست سازمان ها</h1>
                )}

                <div className="flex flex-row items-center">
                    <button
                        onClick={() => setOpenAddUser(true)}
                        className="flex flex-row-reverse items-center py-2 px-8 rounded-lg bg-primary-500 text-white"
                    >
                        {/* <img src="/image/icon/plus.png" className="w-5 ml-2" /> */}
                        <PlusIcon />
                        <p className="mr-2">ایجاد</p>
                    </button>
                    <FilterOrganization users={users} onSelect={setFilterOrg} />
                    <SearchUser onSearch={handleSearch} />
                </div>
            </div>

            {openDeleteMulti && (
                <DeleteMultiUsers users={selectedUsers} close={setOpenDeleteMulti} openError={openError} openSuccess={openSuccess} />
            )}
        </>
    );
}
export default UserHeader;